import appApi from "@/api/appApi";

export default {
  async getServerInfo() {
    return await appApi.get("/site/discord").then(({ data }) => data);
  }
};
